{
  "title": "Distort Value",
  "source": "Acquisitions Inc.",
  "levelAndSchool": "1st-level Illusion",
  "level": 1,
  "castingTime": "1 minute",
  "range": "Touch",
  "components": "V",
  "duration": "8 hours",
  "description": [
    "You cast this spell on an object no more than 1 foot on a side, doubling the object's perceived value by adding illusionary flourish or reducing its perceived value by half with the help of illusionary dents and scratches. Anyone examining the object must roll an Investigation check against your spell DC.",
    "At Higher Levels. When you cast this spell using a higher spell slot, you increase the size of the object by 1 foot per spell slot over 1st."
  ],
  "spellLists": ["bard", "arcane-trickster", "sorcerer", "warlock", "wizard"]
}
